module.exports = __webpack_public_path__ + "static/media/Health.88b702f8.png";